const config = {
  // backendUrl: "http://54.159.32.166:3000/api",
  // backendUrl: "http://localhost:5000/api",
  backendUrl: "https://rmbackend.nucleussolution.com/api",
}

export default config
